import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId70920: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/EMEA_Autumn_Switzerland_1400x600.jpg",
  },
  car: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    driveAgeCheckbox: true,
    includeGT: false,
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/FR.HPR.012021.pdf",
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
